export default __webpack_public_path__ + "media/images/blog/blog-03-770x520-43c678d7fe333b9549e7e95e849da885.jpg";